<template>
    <div class="page">
        <transition name="fade-transition">
            <v-container v-if="profileUser" :class="{'py-3 px-0': phoneOnly, 'py-6': pcOnly}">
                <div class="py-4 px-5 rounded lg:bordered">
                    <div class="d-flex flex-column flex-lg-row justify-lg-space-between align-center">
                        <div class="d-flex align-center">
                            <div>
                                <div>
                                    <v-avatar :size="pcOnly ? 60 : 56" rounded class="bordered">
                                        <v-img :src="profileUser.avatar"></v-img>
                                    </v-avatar>
                                </div>
                            </div>
                            <div class="ms-6">
                                <div class="strong-text--text font-weight-semibold mb-1" style="font-size: 18px">{{profileUser.name}}</div>
                                <div class="details-text muted--text font-weight-semibold">{{profileUser.grade ? profileUser.grade.name : 'طالب'}}</div>
                            </div>
                        </div>
                        <div :class="{'mt-6 w-100': phoneOnly}">
                            <div v-if="profileUser.profile_qr_code" class="mb-2">
                                <v-btn color="primary" block @click="qrcodeDialog = true" depressed>
                                    <v-icon left>mdi-qrcode</v-icon>
                                    <span>رمز QR للمسح السريع</span>
                                </v-btn>
                            </div>
                            <v-btn color="primary" :text="!isDark" outlined block @click="openAvatarUpload" :disabled="uploadingPhoto" :loading="uploadingPhoto">
                                <v-icon left>mdi-image-edit</v-icon>
                                <span>تعديل الصورة الشخصية</span>
                            </v-btn>
                            <input type="file" hidden ref="avatarInput" accept="image/*" @change="handleAvatarUpload"  />
                        </div>
                    </div>
                </div>
                <v-list class="lg:bordered my-5 px-3">
                    <template v-for="(item) in infoItems">
                        <v-list-item :key="item.name" class="py-1" v-on="!!item.dialogAction ? {click: item.dialogAction} : {}" v-ripple="phoneOnly && !!item.dialogAction ? {class: 'ripple--color'} : false">
                            <v-list-item-icon>
                                <v-icon :color="item.color">{{item.icon}}</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-subtitle>{{item.label}}</v-list-item-subtitle>
                                <v-list-item-title :class="{'ltr-dir text-right': item.ltr}">{{item.value}}</v-list-item-title>
                            </v-list-item-content>
                            <v-list-item-icon v-if="!!item.dialogAction" class="my-auto ms-2">
                                <v-icon size="20" color="grey lighten-1">mdi-pencil</v-icon>
                            </v-list-item-icon>
                        </v-list-item>
                        <v-divider inset :key="'d-'+ item.name" style="opacity: 0.75"></v-divider>

                    </template>
                    <v-list-item class="py-1" @click="changePasswordDialog = true;" v-ripple="phoneOnly ? {class: 'ripple--color'} : false">
                        <v-list-item-icon>
                            <v-icon color="strong-text">mdi-form-textbox-password</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-subtitle>كلمة المرور</v-list-item-subtitle>
                            <v-list-item-title>***********</v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-icon class="my-auto ms-2">
                            <v-icon size="19" color="grey lighten-1">mdi-cog</v-icon>
                        </v-list-item-icon>
                    </v-list-item>
                </v-list>
                
                <!-- dialogs -->
                <v-dialog v-model="editNameDialog" max-width="350" overlay-color="#000" overlay-opacity="0.8">
                    <v-card>
                        <v-card-title>تعديل الاسم</v-card-title>
                        <v-card-text class="mt-3">
                            <v-text-field v-model="editedName" placeholder="أدخل اسمك" label="الاسم" name="name" hide-details :disabled="updatingUser"></v-text-field>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer />
                            <v-btn text color="muted" @click="editNameDialog = false;">
                                إلغاء
                            </v-btn>
                            <v-btn text color="primary" @click="updateUserAction({name: editedName}, 'editNameDialog')" :loading="updatingUser">
                                حفظ التغييرات
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
                <v-dialog v-model="editGradeDialog" max-width="350" overlay-color="#000" overlay-opacity="0.8">
                    <v-card>
                        <v-card-title>تعديل الصف الدراسي</v-card-title>
                        <v-card-text class="mt-3">
                            <v-select placeholder="اختر الصف الدراسي" label="الصف الدراسي" name="grade" hide-details :items="gradesItems" v-model="editedGradeId" :disabled="updatingUser"></v-select>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer />
                            <v-btn text color="muted" @click="editGradeDialog = false;">
                                إلغاء
                            </v-btn>
                            <v-btn text color="primary" @click="updateUserAction({grade_id: editedGradeId}, 'editGradeDialog')" :loading="updatingUser">
                                حفظ التغييرات
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
                <v-dialog v-if="profileUser.profile_qr_code" v-model="qrcodeDialog" max-width="275" overlay-color="#000" overlay-opacity="0.65">
                    <v-card>
                        <!-- <v-card-title>رمز QR للمسح السريع</v-card-title> -->
                        <v-card-text class="pa-3 d-flex align-center justify-center flex-column">
                            <div v-if="profileUser.profile_qr_code">
                                <qrcode :value="profileUser.profile_qr_code" />
                            </div>
                            <div v-if="profileUser.center_name">
                                <v-chip color="primary" outlined label small class="medium-text">{{ profileUser.center_name }}</v-chip>
                            </div>

                            <v-btn absolute top left icon @click="qrcodeDialog=false">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </v-card-text>
                    </v-card>
                </v-dialog>
                <v-dialog v-model="changePasswordDialog" max-width="350" overlay-color="#000" overlay-opacity="0.8">
                    <v-card>
                        <v-card-title>تغيير كلمة المرور</v-card-title>
                        <v-card-text class="mt-3">
                            <v-text-field placeholder="أدخل كلمة المرور الحالية" label="كلمة المرور الحالية" name="current_password" hide-details v-model="currentPassword" :disabled="changingPassword" class="my-5" :append-icon="showCurrentPassword ? 'mdi-eye' : 'mdi-eye-off'" :type="showCurrentPassword ? 'text' : 'password'" @click:append="showCurrentPassword = !showCurrentPassword"></v-text-field> <!-- :loading="loading" -->
                            <v-text-field placeholder="أدخل كلمة المرور الجديدة" label="كلمة المرور الجديدة" name="password" hide-details v-model="newPassword" :disabled="changingPassword" class="my-5" :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'" :type="showPassword ? 'text' : 'password'" @click:append="showPassword = !showPassword"></v-text-field> <!-- :loading="loading" -->
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer />
                            <v-btn text color="muted" @click="changePasswordDialog = false;">
                                إلغاء
                            </v-btn>
                            <v-btn text color="primary" @click="chnagePasswordAction" :loading="changingPassword">
                                تأكيد
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-container>
        </transition>
    </div>
</template>

<script>
// @ is an alias to /src

import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'
import InfinityWrapper from '@/components/default/infinity-wrapper'
import Qrcode from '@/components/default/qrcode'

export default {
    name: "Courses",
    components: {
        Qrcode,
        InfinityWrapper,
    },
    data(){
        return {
            profile: null,
            profileUser: null,
            loading: false,

            qrcodeDialog: false,
            uploadingPhoto: false,

            updatingUser: false,

            editNameDialog: false,
            editedName: '',

            editGradeDialog: false,
            editedGradeId: '',
            
            changePasswordDialog: false,
            showPassword: false,
            showCurrentPassword: false,
            changingPassword: false,
            currentPassword: '',
            newPassword: '',
        }
    },
    computed: {
        ...GlobalComputed,
        infoItems(){
            const user = this.profileUser;
            if (user){
                return [
                    {name: 'id', icon: 'mdi-pound', color: 'text', label: 'معرف الطالب', value: `${user.id}`},
                    {name: 'name', icon: 'mdi-account-box-outline', color: 'text', label: 'اسم الطالب', value: user.name, dialogAction: ()=>{this.editedName = user.name; this.editNameDialog = true;}},
                    {name: 'email', icon: 'mdi-email-outline', color: 'text', label: 'البريد الإلكتروني', value: user.email},
                    {name: 'phone', icon: 'mdi-phone', color: 'text', label: 'رقم الهاتف', value: user.phone, ltr: true},
                    {name: 'grade', icon: 'mdi-school-outline', color: 'text', label: 'الصف الدراسي', value: user.grade ? user.grade.name : '___', dialogAction: ()=>{this.editedGradeId = (user.grade ? user.grade.id : ''); this.editGradeDialog = true;}},
                ];
            }
            return [];
        },
        gradesItems(){
            return this.appData ? this.appData.grades.map(grade=>{
                return {text: grade.name, value: grade.id};
            }) : [];
        },
    },
    watch: {
        loading(loading){
            this.setLinearLoading(loading);
        },
    },
    methods: {
        ...GlobalMethods,
        getProfile(){
            if (!this.loading){
                this.loading = true;
                const url = '/profile';
                this.$store.dispatch('fastGetAction', {url}).then(response=>{
                    this.loading = false;
                    this.profileUser = response.data.user;

                }).catch(()=>{
                    this.showMsg('حدثت مشكلة أثناء تحميل البيانات');
                    this.loading = false;
                });
            }
        },
        openAvatarUpload(){
            if (!this.uploadingPhoto){
                this.$refs.avatarInput.value = '';
                this.$refs.avatarInput.click();
            }
        },
        handleAvatarUpload(event){
            let files = event.target.files;
            if (files && files.length){
                this.uploadAvatar(files[0]);
            }
        },
        uploadAvatar(file){
            let formData = new FormData();
            formData.append('avatar', file);

            if (!this.uploadingPhoto){
                this.uploadingPhoto = true;

                this.$store.dispatch('fastPostAction', {url: '/profile/avatar', data: formData, headers: {'Content-Type': 'multipart/form-data'}}).then(response=>{
                    this.showMsg('تم تغيير الصورة بنجاح', 'success');
                    const user = response.data.user;
                    Object.assign(this.profileUser, user);
                    this.$store.commit('UPDATE_USER', {
                        avatar: user.avatar,
                    });

                    this.uploadingPhoto = false;

                }).catch((e)=>{
                    this.showMsg('حدثت مشكلة أثناء تنفيذ الطلب', 'error');

                    this.uploadingPhoto = false;
                });
            }
        },
        updateUserAction(data, dialog){
            if (!this.updatingUser){
                this.updatingUser = true;

                this.$store.dispatch('fastPutAction', {url: '/profile', data}).then(response=>{
                    this.showMsg('تم حفظ التغييرات بنجاح', 'success');
                    const user = response.data.user;
                    Object.assign(this.profileUser, user);
                    this.$store.commit('UPDATE_USER', {
                        profile_not_completed: user.profile_not_completed,
                        name: user.name,
                        email: user.email,
                        phone: user.phone,
                        grade: user.grade,
                        avatar: user.avatar,
                    });
    
                    this.updatingUser = false;
                    this[dialog] = false;
    
                }).catch(error=>{
                    this.updatingUser = false;
                    if (error.response && error.response.status === 422){
                        // coming errors from backend
                        let errors = error.response.data.errors;
                        this.showMsg(errors[Object.keys(errors)[0]][0]);
                    }else{
                        this.showMsg('حدثت مشكلة أثناء حفظ التغييرات', 'error');
                    }
                });
            }
        },
        chnagePasswordAction(){
            if (!this.changingPassword){
                if (this.currentPassword.length && this.newPassword.length){
                    this.changingPassword = true;

                    const data = {current_password: this.currentPassword, password: this.newPassword};

                    this.$store.dispatch('fastPostAction', {url: '/profile/password', data}).then(response=>{
                        this.showMsg('تم تغيير كلمة المرور بنجاح', 'success');
                        this.changingPassword = false;
                        this.changePasswordDialog = false;
                        
                        this.currentPassword = '';
                        this.newPassword = '';
        
                    }).catch((error)=>{
                        if (error && error.response && error.response.status === 422){
                            // coming errors from backend
                            let errors = error.response.data.errors;
                            this.showMsg(errors[Object.keys(errors)[0]][0]);
                        }else if(error && error.response && error.response.data === 'WRONG_OLD_PASSWORD'){
                            this.showMsg('كلمة المرور الحالية غير صحيحة', 'error');
                        }else{
                            this.showMsg('حدثت مشكلة أثناء إنشاء الحساب', 'error');
                        }
        
                        this.changingPassword = false;
                    });
                }else{
                    this.showMsg('لا تترك الحقول فارغة', 'error');
                }
            }
        },
    },
    mounted(){
        this.getProfile();
    }
};
</script>

<style lang="scss">
.v-skeleton-loader__image{
    height: 150px!important;
}
</style>